<template>
  <div class="settings-section manage-learners-report-downloads">
    <voxy-table
      :id-field="idField"
      :columns="visibleColumns"
      :rows="downloads"
      :total-rows="count"
      :sortable="false"
      :current-page="currentPage"
      :ordering="ordering"
      @change:pagesize="onPageSizeChange"
      @change:ordering="onOrderingChange"
      @change:currentPage="onPageChange"
    >
      <template slot="organization" slot-scope="{ value: organization }">
        {{ getOrganizationName(organization) }}
      </template>
      <template slot="url" slot-scope="{ value: link }">
        <a v-if="link" class="manage-learners-report-downloads__download-link" :href="link" download>
          <font-awesome-icon :icon="['fas', 'download']" />
          Download
        </a>
        <template v-else> Not ready </template>
      </template>
    </voxy-table>
    <div class="manage-learners-report-downloads__loader" v-if="isFetching">
      <voxy-spinner color="#ffffff" :size="48" :stroke="2"></voxy-spinner>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex';
import { mapWaitingGetters } from 'vue-wait';
import { VoxySpinner } from '@voxy-team/vue-voxy';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import VoxyTable from '@/components/voxy/VoxyTable';

export default {
  name: 'ManageLearnersReportDownloads',

  components: {
    FontAwesomeIcon,
    VoxyTable,
    VoxySpinner,
  },

  data() {
    return {
      idField: 'created',
    };
  },

  computed: {
    ...mapGetters('manageLearnersReportDownloads', ['visibleColumns']),

    ...mapState('manageLearnersReportDownloads', ['count', 'currentPage', 'downloads', 'ordering']),

    ...mapWaitingGetters({
      isFetching: 'fetching report downloads',
    }),
  },

  methods: {
    ...mapActions('manageLearnersReportDownloads', ['FETCH_DOWNLOADS']),

    ...mapMutations('manageLearnersReportDownloads', ['SET_CURRENT_PAGE', 'SET_ORDERING', 'SET_PAGE_SIZE']),

    getOrganizationName(organization) {
      return organization ? organization.name : '-';
    },

    onPageSizeChange({ pageSize }) {
      this.SET_PAGE_SIZE({ pageSize });
      this.FETCH_DOWNLOADS();
    },

    onOrderingChange({ ordering }) {
      this.SET_ORDERING({ ordering });
      this.FETCH_DOWNLOADS();
    },

    onPageChange({ currentPage }) {
      this.SET_CURRENT_PAGE({ currentPage });
      this.FETCH_DOWNLOADS();
    },
  },
};
</script>

<style lang="scss">
@import '~styles/tools/variables';

.manage-learners-report-downloads {
  position: relative;

  &__loader {
    display: flex;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding-top: 3rem;
    background: rgba($night-rider-grey, 0.5);
  }

  &__download-link {
    cursor: pointer;
    color: #1bccde;
  }
}
</style>
